// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"349":"c8461e27","354":"955eae98","838":"5113efe9"}[chunkId] + ".js";
};